"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModalFunctions = void 0;
const getModalFunctions = _ref => {
  let {
    isCloseFromOutsideEnabled = true,
    layout,
    onClose
  } = _ref;
  const handleClose = event => {
    event.stopPropagation();
    if (onClose) {
      onClose(event);
    }
  };
  const handleCloseFromOutside = event => {
    if (isCloseFromOutsideEnabled && layout !== 'inline') {
      handleClose(event);
    }
  };
  return {
    handleClose,
    handleCloseFromOutside
  };
};
exports.getModalFunctions = getModalFunctions;